// frontend/src/App.jsx
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/Layout/PrivateRoute';
import Sidebar from './components/Layout/Sidebar';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Tasks from './pages/Tasks';
import CreateTask from './pages/CreateTask';
import EditTask from './pages/EditTask';
import TaskDetails from './pages/TaskDetails';
import UsersStats from './pages/UsersStats';
import Templates from './pages/Templates';
import UpcomingTasks from './pages/UpcomingTasks';
import Users from './pages/Users';
import BulkUpload from './pages/BulkUpload';
import './index.css';

// Layout component with sidebar state management
const AppLayout = ({ children }) => {
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

    return (
        <div className="app-layout">
            <Sidebar onCollapse={setIsSidebarCollapsed} />
            <div className={`main-content ${isSidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
                <div className="content-wrapper">
                    {children}
                </div>
            </div>
        </div>
    );
};

function App() {
    return (
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <AuthProvider>
                <Toaster 
                    position="top-right"
                    toastOptions={{
                        duration: 4000,
                        style: {
                            background: '#1e293b',
                            color: '#fff',
                            borderRadius: '12px',
                            padding: '16px',
                        },
                        success: {
                            duration: 3000,
                            iconTheme: {
                                primary: '#10b981',
                                secondary: '#fff',
                            },
                        },
                        error: {
                            duration: 4000,
                            iconTheme: {
                                primary: '#ef4444',
                                secondary: '#fff',
                            },
                        },
                    }}
                />
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/" element={<PrivateRoute />}>
                        <Route index element={<Navigate to="/dashboard" />} />
                        <Route path="dashboard" element={
                            <AppLayout>
                                <Dashboard />
                            </AppLayout>
                        } />
                        <Route path="tasks" element={
                            <AppLayout>
                                <Tasks />
                            </AppLayout>
                        } />
                        <Route path="upcoming" element={
                            <AppLayout>
                                <UpcomingTasks />
                            </AppLayout>
                        } />
                        <Route path="create-task" element={
                            <AppLayout>
                                <CreateTask />
                            </AppLayout>
                        } />
                        <Route path="edit-task/:taskId" element={
                            <AppLayout>
                                <EditTask />
                            </AppLayout>
                        } />
                        <Route path="task/:taskId" element={
                            <AppLayout>
                                <TaskDetails />
                            </AppLayout>
                        } />
                        <Route path="users-stats" element={
                            <AppLayout>
                                <UsersStats />
                            </AppLayout>
                        } />
                        <Route path="users" element={
                            <AppLayout>
                                <Users />
                            </AppLayout>
                        } />
                        <Route path="templates" element={
                            <AppLayout>
                                <Templates />
                            </AppLayout>
                        } />
                        <Route path="bulk-upload" element={
                            <AppLayout>
                                <BulkUpload />
                            </AppLayout>
                        } />
                    </Route>
                </Routes>
            </AuthProvider>
        </Router>
    );
}

export default App;